'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

export const useSidebarPadding = () => {
  const pathname = usePathname();

  useEffect(() => {
    const controlPaddingElement = document.querySelector('.control-padding');

    if (!controlPaddingElement || !(controlPaddingElement instanceof HTMLElement)) {
      return;
    }

    controlPaddingElement.classList.remove('md:ml-72', 'lg:mr-8', 'md:ml-20', 'md:ml-32');
    controlPaddingElement.style.marginLeft = '0';
    controlPaddingElement.style.marginRight = '0';
  }, [pathname]);
};
